module.exports = __webpack_public_path__ + "media/images/bornachot-bfc38302983bcf19931f16c578e974fe.jpg";